import React from "react";
import { useDispatch } from "react-redux";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Grid,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";
import { getLocalizedString } from "@icarius-localization/strings";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import useHandleForm from "./useHandleForm";
import TextFieldMultiline from "@icarius-common/textFieldMultiline";

const CommentDialog = (props) => {

    const {
        open,
        data,
        title,
        handleClose,
        commentFunctionArgs,
    } = props;

    const dispatch = useDispatch();

    const create = (dataToSend) => {
        commentFunctionArgs.function(...[...commentFunctionArgs.args, dataToSend.comment]);
        handleClose();
    }

    const openValidationError = () => {
        dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
    }

    const {
        formData,
        setFormValue,
        submit,
    } = useHandleForm(data, create, openValidationError);

    return (
        <Dialog
            open={open}
            TransitionComponent={DialogTransition}
            PaperComponent={PaperDraggable}
            maxWidth={"md"}
            fullWidth={true}
        >
            <div className={"dialog-container"}>
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    {title}
                    <DialogTitleDivider />
                </DialogTitle>
                <DialogContent>
                    <Grid container item xs={12}>
                        <TextFieldMultiline
                            fullWidth
                            label={getLocalizedString("comment")}
                            rows={5}
                            margin={"none"}
                            value={formData.comment}
                            inputProps={{ spellCheck: 'false' }}
                            onChange={(e) => setFormValue(e.target.value, "comment")}
                        />
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <ButtonDialogAction onClick={submit} isAccept text={getLocalizedString("accept")} />
                </DialogActions>
            </div>
        </Dialog>
    );
}

export default CommentDialog;
